import Nav from "../Nav";
import Footer from "../Footer";
import "../styles/list-management.scss";
import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import axios from "axios";
import moment from "moment";
import AddIcon from "@mui/icons-material/Add";
import { Modal } from "@mui/material";
import ListCheckout from "../AssetManagement/ListCheckout";
import { getAssetLocations } from "../../utils/utilsAPI";
import IndvList from "./IndvList";
import InventoryIcon from "@mui/icons-material/Inventory";
import ListArchive from "./ListArchive";

export default function ListManagement() {
  const url = process.env.REACT_APP_URL;
  const [listsFixed, setListsFixed] = useState([]);
  const [listsDisplayed, setListsDisplayed] = useState([]);
  const [searchedListName, setSearchedListName] = useState("");
  const [assetLocations, setAssetLocations] = useState([]);
  //Reload & Loader
  const [reload, setReload] = useState(false);
  const [loader, setLoader] = useState(false);
  //Modals
  const [openView, setOpenView] = useState(false);
  const [openArchive, setOpenArchive] = useState(false);

  useEffect(() => {
    fetchAssetLists();
    //Bring in Locations
    getAssetLocations()
      .then((res) => {
        setAssetLocations(res.locations);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [reload]);

  const fetchAssetLists = async () => {
    await axios
      .get(`${url}/assets/fetch-lists`)
      .then((res) => {
        setListsFixed(res.data.lists);
        setListsDisplayed(res.data.lists);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSearch = (name) => {
    setSearchedListName(name);
    let filteredLists = listsFixed.filter((list) => {
      let _listName = list.name.toLowerCase();

      return _listName.includes(name.toLowerCase());
    });
    setListsDisplayed(filteredLists);
  };

  const refreshAssets = () => {
    setReload(!reload);
  };

  return (
    <>
      <Nav />
      <main className="list-management">
        <h1 className="page-header">
          List Managment {` - ${localStorage.getItem("username")}`}
        </h1>
        <section className="list-management-content">
          <section className="search-section">
            <input
              type="text"
              value={searchedListName}
              onChange={(e) => handleSearch(e.target.value)}
              placeholder="Search by List Name"
              maxLength={50}
            />
          </section>
          <div className="header-btns">
            <Button
              variant="contained"
              onClick={() => setOpenArchive(true)}
              color="warning"
            >
              <InventoryIcon fontSize="large" />
            </Button>
            <Button variant="contained" onClick={() => setOpenView(true)}>
              <AddIcon fontSize="large" />
            </Button>
          </div>
          {listsDisplayed.length > 0 ? (
            <secton className="list-table-container">
              <table className="list-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Created</th>
                    <th>CSV</th>
                    <th>Mass Check In</th>
                    <th>Edit</th>
                    
                  </tr>
                </thead>
                <tbody>
                  {listsDisplayed.map((l, i) => {
                    let csvData = [l];

                    let newcsvData = csvData
                      .map((list) => {
                        return list.assets.map((asset) => ({
                          listId: list.listId,
                          listName: list.name,
                          createdAt: moment(list.createdAt).format("DD/MM/YY"),
                          assetId: asset.assetId,
                          assetName: asset.assetName,
                          serialNumber: asset.serialNumber,
                        }));
                      })
                      .flat();

                    return (
                      <IndvList
                        newcsvData={newcsvData}
                        l={l}
                        refreshAssets={refreshAssets}
                        archive={false}
                        assetLocations={assetLocations}
                      />
                    );
                  })}
                </tbody>
              </table>
            </secton>
          ) : (
            <h2>No lists</h2>
          )}
        </section>
        {/* MODALS */}
        <Modal open={openView}>
          <ListCheckout
            handleClose={setOpenView}
            assetLocations={assetLocations}
            refreshAssets={refreshAssets}
          />
        </Modal>
        <Modal open={openArchive}>
          <ListArchive setOpenArchive={setOpenArchive} />
        </Modal>
      </main>
      <Footer />
    </>
  );
}
